module.exports = __webpack_public_path__ + "static/media/party_pack_128.b79d3470.png";